<template>
    <div>
        <h2>{{ $t('subscribe-notifications') }}</h2>
        <p>{{ $t('subscribe-detail') }}</p>
        <div class="row">
            <div class="col-12 col-md-6 form-group">
                <label for="email-address">{{ $t('email-address') }}</label>
                <input @input="email_typing"
                       @blur="email_blurring"
                       v-model="email"
                       class="form-control"
                       :class="{'is-valid': display_email_valid, 'is-invalid': display_email_error }"
                       type="email"
                       id="email-address"
                       placeholder="name@example.com">
                <small class="form-text text-muted">
                    {{ $t('email-address-extra')}}
                </small>
                <div v-if="display_email_error" class="invalid-feedback">
                    {{ $t('incorrect-email') }}
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <p>
                    <span v-if="parameters.all">{{ $t('sign-for-all') }}</span>
                    <span v-if="parameters.wards || parameters.neighbourhoods">{{ $t('sign-for-some', {list: list}) }}</span>
                    <span v-if="parameters.location">{{ $t('sign-for-near',{ radius: selected_location.radius, address: selected_location.address }) }}</span>
                    <button v-if="!parameters.all" type="button" class="ml-2 btn btn-sm btn-secondary" @click="clear">{{ $t('auto_complete.clear') }}</button>
                </p>
            </div>
        </div>
        <div class="narrow-subscription">
            <h3>{{ $t('narrow-subscription') }}</h3>
            <p>{{ $t('narrow-subscription-more') }}</p>
						<nav>
            <ul class="nav nav-pills flex-column flex-md-row" aria-orientation="vertical" role="tablist">
                <li class="nav-item">
                    <a href="" v-on:click.stop.prevent="set_tab('location')" class="nav-link cursor" :class="{'active': tab==='location'}" role="tab">
                        {{ $t('address-tab') }}
                    </a>
                </li>
                <li class="nav-item">
                    <a href="" v-on:click.stop.prevent="set_tab('ward')" class="nav-link cursor" :class="{'active': tab==='ward'}" role="tab">
                        {{ $t('ward-tab') }}
                    </a>
                </li>
                <li class="nav-item">
                    <a href="" v-on:click.stop.prevent="set_tab('neighbourhood')" class="nav-link cursor" :class="{'active': tab==='neighbourhood'}" role="tab">
                        {{ $t('neighbourhood-tab') }}
                    </a>
                </li>
            </ul>
						</nav>

            <div class="tab-content">
                <div v-if="tab==='location'" class="tab-pane fade show active" role="tabpanel">
                    <AddressLookup v-on:choose="set_location" :location="selected_location" v-on:clear="selected_location = {}"></AddressLookup>
                </div>
                <div v-if="tab==='ward'" class="tab-pane fade show active" role="tabpanel">
                    <WardMap v-on:choose="set_ward" :wards="selected_wards"></WardMap>
                </div>
                <div v-if="tab==='neighbourhood'" class="tab-pane fade show active" role="tabpanel">
                    <NeighbourhoodMap v-on:choose="set_neighbourhoods" :neighbourhoods="selected_neighbourhoods"></NeighbourhoodMap>
                </div>
            </div>
        </div>

        <div v-if="success" class="alert alert-success mt-4 mb-2" role="alert">
            {{ $t('success-message') }}
        </div>
        <div v-if="error" class="alert alert-danger mt-4 mb-2" role="alert">
            {{ $t('error-message') }}
        </div>
        <vue-recaptcha ref="recaptcha"
                       @verify="onVerify" :sitekey="$CAPTCHA_KEY" :loadRecaptchaScript="true">
        </vue-recaptcha>
        <button type="button" class="mt-2 mb-4 btn btn-primary" :disabled="!valid_form" @click="subscribe">{{ $t('subscribe') }}</button>
        <div class="callout callout-info">
            {{ $t('fippa') }}
        </div>

    </div>
</template>

<script>
import AddressLookup from '@/components/AddressLookup'
import WardMap from '@/components/WardMap'
import NeighbourhoodMap from '@/components/NeighbourhoodMap'
    import axios from 'axios'
    import VueRecaptcha from 'vue-recaptcha'
let qs = require("qs");
	export default {
        components: { AddressLookup, NeighbourhoodMap, WardMap, VueRecaptcha },
		data() {
			return {
				email: '',
				selected_wards: [],
				selected_neighbourhoods: [],
				selected_location: {},
				tab: 'location',
				email_touched: false,
				email_blur: false,
				error: false,
                success: false,
                is_robot: true
			}
		},
		created() {
			if (this.$route.params.parameters) {
				const params = this.decode_subscribe_parameters(this.$route.params.parameters);
				if (params.ward) {
					this.selected_wards.push(params.ward);
					this.tab="ward";
				} else if (params.neighbourhood) {
					this.selected_neighbourhoods.push(params.neighbourhood);
					this.tab="neighbourhood"
				}
			}
		},

		watch: {
		},

		methods: {
			email_typing(e) {
				this.email_touched = true;
				this.email_blur = false;
			},

			email_blurring() {
				this.email_blur = true;
			},

			onVerify: function (response) {
				if (response) this.is_robot = false;
			},

			set_ward(wards) {
				this.selected_wards = wards;
				this.selected_neighbourhoods = [];
				this.selected_location = {};
			},

			set_neighbourhoods(neighbourhoods) {
				this.selected_neighbourhoods = neighbourhoods;
				this.selected_wards = [];
				this.selected_location = {};
			},

			set_location(data) {
				this.selected_neighbourhoods = [];
				this.selected_ward = [];
				const radius = data.radius;
				const location = data.address;
				const address = {
					radius: radius,
					address: location.full_address,
					lat: parseFloat(location.location.latitude),
					lng: parseFloat(location.location.longitude)
				}
				this.selected_location = address;
			},

			async subscribe() {
				try {
					this.error = false;
					const data = { email: this.email, parameters: this.parameters, lang:"en" };
					const url = this.$NOTIFICATION_API + '/api/subscribe';
					const results = await axios.post(url,qs.stringify(data));
					if (results.status === 200) {
						this.success = true;
					}
				} catch(err) {
					this.error = true;
				}
			},

			set_tab(tab) {
				this.tab = tab;
			},

			clear() {
				this.tab = 'location';
				this.selected_location = {};
				this.selected_neighbourhoods = [];
				this.selected_wards = [];
			}
		},

		computed: {
			display_email_error() {
				return (this.email_blur && this.email_touched && !this.valid_email);
			},

			display_email_valid() {
				return (this.valid_email && this.email_touched && this.email_blur);
			},

			valid_form() {
                return (this.valid_email && !this.is_robot);
			},

			valid_email() {
			    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
 				return re.test(String(this.email).toLowerCase());
			},

			list() {
				var str = '';
				var elements = [];
				if (this.parameters.wards) {
					elements = this.parameters.wards;
				} else if (this.parameters.neighbourhoods) {
					elements = this.parameters.neighbourhoods;
				}
				if (elements.length > 2) {
					//remove the pointer as we're going to pop elements
					elements = JSON.parse(JSON.stringify(elements));
					const last = elements.pop();
					str = elements.join(', ');
					str += ', ' + this.$t('or') + ' ' + last;
				} else if (elements.length > 1) {
					str = elements.join(' ' + this.$t('or') + ' ');
				} else if (elements.length) {
					return elements[0];
				}
				return str;
			},

			parameters() {
				let params = {};
				if (this.selected_wards.length) {
					params.wards = this.selected_wards;
				} else if (this.selected_neighbourhoods.length) {
					params.neighbourhoods = this.selected_neighbourhoods;
				} else if (typeof this.selected_location.lat === 'number' && typeof this.selected_location.lng === 'number') {
					params.location = this.selected_location;
				} else {
					params.all = true;
				}
				return params;
			}
		},
	}
</script>

<style>
.narrow-subscription {
	padding: 15px;
	background-color: #F8F9FA;
	border-radius: 4px;
}
</style>
